import React from "react";

interface NotifBadgedProps {
  src: string;
  spanContent: string | number;
}

const NotifBadged: React.FC<NotifBadgedProps> = ({ src, spanContent }) => {
  return (
    <>
      <div className="relative">
        <img
          src={src}
          alt="notification"
          className="relative min-w-[24px]"
          width={24}
          height={24}
        />
        <span className="absolute font-extrabold top-4 -right-2 px-[5px] py-[0px] bg-primary-200 text-gray-800  rounded-[6px]">
          {spanContent}
        </span>
      </div>
    </>
  );
};

export default NotifBadged;
